import { PARTY_DISCOUNT_DETAILS } from "../../types/PartyDiscountType";
import axios from "axios";

const detailPartyDiscount = (data) => {
	return {
		type: PARTY_DISCOUNT_DETAILS,
		payload: data,
	};
};

export const loadSinglePartyDiscount = (id) => {
	//dispatching with an call back function and returning that
	return async (dispatch) => {
		try {
			const data = await axios.get(`product-currency/${id}`);
			//dispatching data
			dispatch(detailPartyDiscount(data));
			return data;
		} catch (error) {
			console.log(error.message);
		}
	};
};
